
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import {
  Product
} from "~/node_modules/sitisjs/dist/internal/sections/products/models/Product";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default BaseCmsBlock.extend({
  name: "TransportListTemplatesBlock",

  data: function () {
    return {
      transportList: [],

      swiperOptions: {
        spaceBetween: 10,
        slidesPerView: 1.2,
        slidesPerGroup: 1.2,

        breakpoints: {
          1200: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1024: {
            spaceBetween: 20,
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          860: {
            slidesPerView: 2.6,
            slidesPerGroup: 2.6,
          },
          640: {
            slidesPerView: 2.2,
            slidesPerGroup: 2.2,
          },
        },
        navigation: {
          prevEl: '.transport-list-templates__button-navition--prev',
          nextEl: '.transport-list-templates__button-navition--next'
        },
      },

      isLoadTransportList: true
    }
  },

  computed: {
    localValues: function () {
      return this.externalData?.TransportListTemplatesBlock || this.values || {}
    },
    version: function () {
      return this.localValues?.versionBlock
    },
  },

  mounted: async function () {
    await this.getTransport();
  },

  components: {
    Swiper,
    SwiperSlide,
    ProductsComponent: () => import("./components/OurFleetVehiclesTemplateBlock/Products")
  },

  watch: {
    localValues: async function () {
      await this.getTransport();
    }
  },

  methods: {
    getTransport: async function () {
      const filter = this.localValues?.filter || "";
      if (!filter) {
        return
      }
      if (!this.isLoadTransportList) {
        return
      }
      this.isLoadTransportList = false;

      let expand = [];
      if (this.version >= 2) {
        expand.push(...['short_characteristics', 'characteristics'])
      }

      let mainCategoryTransport = this.externalData.TransportListTemplatesBlock?.category?.dynamicFields?.main_category_transport;
      let transport = await this.$api.agent.transport.get(`/categories/catalog/products?per-page=999&group=2&${ filter }&expand=${expand.join(',')}`).then((res) => {
        const items = res?.data || []
        return items.map((t) => new Product(t))
      }).catch(() => {
        return []
      });
      if (!!mainCategoryTransport) {
        mainCategoryTransport = Number.parseFloat(mainCategoryTransport);
        transport = transport.sort((a, b) => {
          if (a?.category?.id === mainCategoryTransport) {
            return -1
          }
          return 0
        })
      }
      this.transportList = transport;
    }
  }
});
